import { backendVersion, globalAxios } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    campaignRewardList: [],
    campaignRewardDetail: {
      campaign_province: [],
      campaign_condition: [],
      campaign_level: [],
    },
    campaignMarketingList: [],
  },
  mutations: {
    editCampaignMarketing(state, data) {
      let index = state.campaignMarketingList.findIndex(
        (val) => val.dm_id == data.dm_id
      );
      state.campaignMarketingList.splice(index, 1, data);
    },
    addCampaignMarketing(state, data) {
      state.campaignMarketingList.push(data);
    },
    deleteCampaignMarketing(state, item) {
      let index = state.campaignMarketingList.indexOf(item);
      state.campaignMarketingList.splice(index, 1);
    },
    setCampaignMarketingList(state, data) {
      state.campaignMarketingList = data;
    },
    setCampaignRewardList(state, data) {
      state.campaignRewardList = data.map(val => {
        return { ...val, status: val.campaign_active == 2 || val.campaign_active == 4 ? true : false }
      });
    },
    setCampaignRewardDetail(state, data) {
      state.campaignRewardDetail = data;
    },
    addCampaignReward(state, data) {
      data.status = data.campaign_active == 2 || data.campaign_active == 4 ? true : false;
      state.campaignRewardList.unshift(data);
    },
    deleteCampaignReward(state, ID) {
      let index = state.campaignRewardList.findIndex(
        (val) => val.campaign_id == ID
      );
      state.campaignRewardList.splice(index, 1);
    },
  },
  actions: {
    // Crypto Campaign Actions
    async fetchTransactionCryptoById({ dispatch }, campaign_id) {
      const url = `/api/v1/crypto/campaigns/transactions/${campaign_id}`;
      try {
        const res = await globalAxios.get(url);
        return res.msg === false ? [] : res.data;
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return [];
      }
    },

    async updateCampaignCrypto({ dispatch }, payload) {
      const url = `/api/v1/crypto/campaigns`;
      try {
        const res = await globalAxios.put(url, payload);
        return res.msg !== false;
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return false;
      }
    },

    async createCampaignCrypto({ dispatch }, payload) {
      const url = "/api/v1/crypto/campaigns";
      try {
        const res = await globalAxios.post(url, payload);
        return res.msg === false ? [] : res.data;
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return [];
      }
    },

    async editCampaignCrypto({ dispatch }, payload) {
      const url = "/api/v1/crypto/campaigns";
      try {
        const res = await globalAxios.put(url, payload);
        return res.msg === false ? [] : res.data;
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return [];
      }
    },

    async fetchCampaignCrypto({ dispatch }) {
      const url = "/api/v1/crypto/campaigns";
      try {
        const res = await globalAxios.get(url);
        return res.msg === false ? [] : res.data;
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return [];
      }
    },

    // Marketing Campaign Actions
    async deleteCampaignMarketing({ commit, dispatch }, { item, province }) {
      const url = `/api/v1/${province}/delete/campaignMarketing/${item.dm_id}`;
      try {
        const res = await globalAxios.delete(url);
        if (res.msg !== false) {
          commit("deleteCampaignMarketing", item);
          return true;
        }
        return false;
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return false;
      }
    },

    async changStatusCampaignMarketing({ dispatch }, { item, province }) {
      const url = `/api/v1/${province}/edit/campaignMarketing/${item.dm_id}`;
      try {
        const res = await globalAxios.put(url, item);
        return res.msg !== false;
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return false;
      }
    },

    async editCampaignMarketing({ commit, dispatch }, { item, province }) {
      const url = `/api/v1/${province}/edit/campaignMarketing/${item.dm_id}`;
      try {
        const res = await globalAxios.put(url, item);
        if (res.msg === false) {
          return false;
        }
        if (res.msg === true) {
          commit("editCampaignMarketing", res.data);
          return res;
        }
        return false;
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return false;
      }
    },

    async getCampaignMarketing({ commit, dispatch }, province) {
      const url = `/api/v1/${province}/list/campaignMarketing`;
      try {
        const res = await globalAxios.get(url);
        if (res.msg === false) {
          return [];
        }
        if (res.msg === true) {
          commit("setCampaignMarketingList", res.data);
          return res;
        }
        return [];
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return [];
      }
    },

    async addCampaignMarketing({ commit, dispatch }, { form, province }) {
      const url = `/api/v1/${province}/create/campaignMarketing`;
      try {
        const res = await globalAxios.post(url, form);
        if (res.msg !== false) {
          commit("addCampaignMarketing", res.data);
          return res;
        }
        return "error";
      } catch (error) {
        dispatch("disconnectNetwork", error, { root: true });
        return "error";
      }
    },

    // Reward Campaign Actions
    async changeStatusCampaignReward({ dispatch }, ID) {
      let url =
        backendVersion.version + "/backoffice/campaign/editStatus/" + ID;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        alert("Can't change this campaign status.");
        return false;
      } else {
        if (res.msg == true) {
          return true;
        } else {
          alert("Can't change this campaign status.");
          return false;
        }
      }
    },
    async deleteCampaignReward({ dispatch, commit }, ID) {
      let url = backendVersion.version + "/backoffice/campaign/delete/" + ID;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        alert("Can't delete this campaign.");
        return false;
      } else {
        if (res.msg == true) {
          commit("deleteCampaignReward", ID);
          return true;
        } else {
          alert("Can't delete this campaign.");
          return false;
        }
      }
    },
    async createCampaignReward({ dispatch, commit }, form) {
      let url = backendVersion.version + "/backoffice/campaign/create";
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        console.log(res);
        if (res.msg == true) {
          commit("addCampaignReward", res.data);
          return true;
        } else {
          return false;
        }
      }
    },
    async getCampaignRewardList({ dispatch, commit }) {
      let url = backendVersion.version + "/backoffice/campaign/list";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("setCampaignRewardList", res.data);
        return res;
      }
    },
    async getCampaignRewardDetail({ dispatch, commit }, ID) {
      let url = backendVersion.version + "/backoffice/campaign/" + ID;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("setCampaignRewardDetail", res.data);
        return res;
      }
    },
  },
  getters: {},
};
